import statusbar from 'url:../../../assets/images/home-progress-0.webp';
import trainerProfile1 from 'url:../../../assets/images/trainer-profile-1.webp';
import trainerProfile2 from 'url:../../../assets/images/trainer-profile-2.webp';
import trainerProfile3 from 'url:../../../assets/images/trainer-profile-3.webp';
import trainerProfile4 from 'url:../../../assets/images/trainer-profile-4.webp';
import trainerProfile5 from 'url:../../../assets/images/trainer-profile-5.webp';
import trainerProfile6 from 'url:../../../assets/images/trainer-profile-6.webp';
import trainerProfile7 from 'url:../../../assets/images/trainer-profile-7.webp';
import trainerProfile8 from 'url:../../../assets/images/trainer-profile-8.webp';
import trainerProfile9 from 'url:../../../assets/images/trainer-profile-9.webp';

export const trainerProfileAssets = {
  statusbar,
  trainerProfile1,
  trainerProfile2,
  trainerProfile3,
  trainerProfile4,
  trainerProfile5,
  trainerProfile6,
  trainerProfile7,
  trainerProfile8,
  trainerProfile9,
} as const;

export const trainerProfileAssetList = Object.values(trainerProfileAssets);
